import Router from "vue-router";
import Cookies from 'js-cookie';
import store from './store'
import api from './http/api'

//登录

const router = new Router({
    routes: [
        {
            path: '/:schoolcode/home',  //登录
            name: 'home',
            component: () => import('./views/home/home'),
        },
        {
            path: '/:schoolcode/searchData',  //登录
            name: 'searchData',
            component: () => import('./views/searchData/searchData'),
        },
        {
            path: '/:schoolcode/statistics',  //登录
            name: 'statistics',
            component: () => import('./views/statistics/statistics'),
        },
        {
            path: '/:schoolcode/rank',  //登录
            name: 'rank',
            component: () => import('./views/rank/rank'),
        },
        {
            path: '/:schoolcode/notFound',  //登录
            name: 'notFound',
            component: () => import('./views/rank/rank'),
        },
        {
            path: '/:schoolcode/form',  //登录
            name: 'form',
            component: () => import('./views/form/form'),
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});

async function getConfig(next, from, to) {
    let a = await api.getConfig();
    api.getMsgType().then(res => {
        store.commit("SET_MSGTYPE", res.param);
    });
    a.param.menuInfo = JSON.parse(a.param.menuInfo);
    let userConfig = a.param;


    let flag = false;
    Object.keys(userConfig.menuInfo.typeStatistic).forEach(key => {
        if (userConfig.menuInfo.typeStatistic[key] == 1) {
            flag = true;
            return;
        }
    });

    if (!flag) {
        userConfig.menuInfo.typeStatisticStause = 0;
    } else {
        userConfig.menuInfo.typeStatisticStause = 1;
    }
    flag = false;
    Object.keys(userConfig.menuInfo.statisticRanking).forEach(
        key => {
            if (userConfig.menuInfo.statisticRanking[key] == 1) {
                flag = true;
                return;
            }
        }
    );

    if (!flag) {
        userConfig.menuInfo.statisticRankingStause = 0;
    } else {
        userConfig.menuInfo.statisticRankingStause = 1;
    }


    store.commit("SET_CONFIG", userConfig);

    if (to.name != 'form' && userConfig.menuInfo.homeIndex == 0 && userConfig.menuInfo.dateSelect == 0 && userConfig.menuInfo.typeStatisticStause == 0 && userConfig.menuInfo.statisticRankingStause == 0) {
        next({ name: "form", params: { schoolcode: Cookies.get('SCHOOLCODE') } });
    } else {
        if (!to.name) {
            if (userConfig.menuInfo.homeIndex == 1) {
                next({ name: "home", params: { schoolcode: Cookies.get('SCHOOLCODE') } });
            } else if (userConfig.menuInfo.dateSelect == 1) {
                next({ name: "searchData", params: { schoolcode: Cookies.get('SCHOOLCODE') } });
            } else if (userConfig.menuInfo.typeStatisticStause == 1) {
                next({ name: "statistics", params: { schoolcode: Cookies.get('SCHOOLCODE') } });
            } else if (userConfig.menuInfo.statisticRankingStause == 1) {
                next({ name: "rank", params: { schoolcode: Cookies.get('SCHOOLCODE') } });
            }
        } else {
            if (to.name == 'home' && userConfig.menuInfo.homeIndex != 1) {
                next({ name: "searchData", params: { schoolcode: Cookies.get('SCHOOLCODE') } });
            }
            else if (to.name == 'searchData' && userConfig.menuInfo.dateSelect != 1) {
                next({ name: "statistics", params: { schoolcode: Cookies.get('SCHOOLCODE') } });
            }
            else if (to.name == 'statistics' && userConfig.menuInfo.typeStatisticStause != 1) {
                next({ name: "rank", params: { schoolcode: Cookies.get('SCHOOLCODE') } });
            }
            else if (to.name == 'rank' && userConfig.menuInfo.statisticRankingStause != 1) {
                next({ name: "home", params: { schoolcode: Cookies.get('SCHOOLCODE') } });
            } else {
                next()
            }
        }

    }



}

router.beforeEach((to, from, next) => {
    if (to.params.schoolcode) {
        Cookies.set('SCHOOLCODE', to.params.schoolcode)
        getConfig(next, from, to)
    } else {
        next({ name: 'notFound' })
    }
});


export default router;













